import { defineAuthStore } from "@frontend/common/composables/defineAuthStore";

export const useAuthStore = defineAuthStore();
